import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    previous: String,
    month: String,
    day: String,
    previousDatePresent: Boolean,
    errorMessage: String,
  };
  static targets = ["input", "month", "day"];

  connect() {
    if (this.previousDatePresentValue && this.errorMessageValue) {
      if (this.hasPreviousValue && this.hasInputTarget) {
        this.inputTarget.value = this.previousValue;
        this.inputTarget.setAttribute("value", this.previousValue);
      }
      if (this.hasMonthValue && this.hasMonthTarget) {
        this.monthTarget.innerHTML = this.monthValue;
      }
      if (this.hasDayValue && this.hasDayTarget) {
        this.dayTarget.innerHTML = this.dayValue;
      }
      this.dispatchGoalDateError();
    }

    // Listen for goal-date-error event for SweetAlert
    this._goalDateErrorHandler = this.goalDateErrorHandler.bind(this);
    document.addEventListener("goal-date-error", this._goalDateErrorHandler);
  }

  disconnect() {
    if (this._goalDateErrorHandler) {
      document.removeEventListener("goal-date-error", this._goalDateErrorHandler);
    }
  }

  previousDatePresentValueChanged(value) {
    if (value && this.errorMessageValue) {
      this.dispatchGoalDateError();
    }
  }

  submitForm(event) {
    event.target.form.requestSubmit();
  }

  dispatchGoalDateError() {
    const id = this.element.dataset.id;
    const message = this.errorMessageValue;
    const previous = this.previousValue;
    const event = new CustomEvent("goal-date-error", {
      detail: {
        id: id,
        message: message,
        previous: previous,
      },
    });
    document.dispatchEvent(event);
  }

  goalDateErrorHandler(e) {
    if (window.Swal && e.detail && e.detail.message) {
      Swal.fire({
        icon: "error",
        title: "Invalid Date",
        html: e.detail.message,
      });
    }
  }
}
